<script setup>
import { computed, watch, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useFixturesStore } from '@/stores/fixtures';

const props = defineProps({
  event: Object
});

const router = useRouter();
const fixtures = useFixturesStore()
const isLive = computed(() => props.event.s == 0);
const homeScore = computed(() => lastResult.value?.split('-')[0]);
const awayScore = computed(() => lastResult.value?.split('-')[1]);
const lastResult = ref('0-0');

const showLiveResults = () => {
  router.push(`/in-play/events/${props.event.si}`);
};

const goBack = () => {
  router.go(-1);
};

watch(
  () => props.event?.i,
  (newId) => {
    if (!newId) return;
    fixtures.fetchScoreboards(newId).then(res => {
      if(res){
        lastResult.value =res[0]?.result
      }
    })   
  },
  { immediate: true }
);
</script>

<template>
  <div v-if="isLive" class="evd-LiveStats">
    <div class="evd-LiveBar" @click="showLiveResults">
      <!-- Back Button -->
      <div class="evd-BackButton" @click="goBack"> 
        ←
      </div>

      <!-- Home Team -->
      <h3 class="evd-Participant">{{ event.h }}</h3>

      <!-- Scores -->
      <div class="evd-ScoreBox">
        <h2 class="evd-Score">{{ homeScore }}</h2>
        <h2 class="evd-Score">{{ awayScore }}</h2>
      </div>

      <!-- Away Team -->
      <h3 class="evd-Participant">{{ event.a }}</h3>
    </div>
  </div>
</template>

<style scoped>
.evd-LiveStats {
  @apply xl:max-w-[485px] w-full;
}

.evd-LiveBar {
  @apply border-b border-neutral-600/50 flex items-center justify-between cursor-pointer;
  gap: 6px;
}

.evd-BackButton {
  @apply text-white text-[18px] px-2;
  flex-shrink: 0;
}

.evd-Participant {
  @apply text-[13px] font-bold text-white text-center truncate overflow-hidden;
  flex: 1;
  min-width: 0;
}

.evd-ScoreBox {
  @apply flex items-center justify-center gap-1;
  min-width: 52px;
  flex-shrink: 0;
}

.evd-Score {
  color: var(--color-yellow1);
  font-size: 20px;
  font-weight: 600;
  height: 50px;
  @apply px-1 border-b-2 -mb-px flex items-center justify-center;
  width: 24px;
}

.evd-Score:first-of-type {
  border-color: rgb(240, 240, 240);
}

.evd-Score:last-of-type {
  border-color: rgb(0, 0, 0);
}
</style>